module.exports = __webpack_public_path__ + "static/media/bosnia-and-herzegovina.a63bdd76.svg";